import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import 'antd/dist/antd.css';
import { Layout as AntLayout } from 'antd';

import { SideMenu, Header as CustomHeader } from '../index';
import { privilegesContext } from '../../../contexts/auth';
import { LocationChecker } from '../../LocationChecker/LocationChecker';

import style from './Layout.module.scss';

const { Header, Sider, Content } = AntLayout;

export const Layout = ({
  collapsed = false,
  onToggle,
  menuItems,
  SelectedKey,
  openKeys,
  onOpenChange,
  onSelect,
  onLogout,
  onUsernameClick,
  fullName,
  children,
  portal,
  status,
  username }) => {

  const privileges = useContext(privilegesContext);
  const { i18n } = useTranslation();

  const getfilteredMenu = menu => {
    const tempMenu = menu.map(item => {
      let tempItem;
      if (item.submenu) {
        const submenu = item.submenu.filter(subItem => {
          if (subItem.id === 'public') {
            return true;
          }
          const ids = typeof(subItem.id) == 'number' ? [ subItem.id ] : subItem.id;

          return privileges.some(i => ids.includes(i));
        });
        tempItem = {
          ...item,
          submenu,
          id: (item.id === 'public' && submenu.length) ? item.id : false
        };

        return tempItem;
      }

      return item;
    });

    const filterdMenu = tempMenu.filter(item => privileges.includes(item.id) || item.id === 'public');

    return filterdMenu;
  };

  return (
    <AntLayout className={ style.layout }>
      <LocationChecker portal={ portal } username={ username } />
      <SideMenu
        language={ i18n.language }
        Sider={ Sider }
      // menuItems={ menuItems }
        menuItems={ getfilteredMenu(menuItems) }
        onToggle={ onToggle }
        collapsed={ collapsed }
        SelectedKey={ SelectedKey }
        openKeys={ openKeys }
        onOpenChange={ onOpenChange }
        onSelect={ onSelect }
      />
      <AntLayout>
        <Header className={ style.header } language={ i18n.language }>
          <CustomHeader
            fullName={ fullName }
            onUsernameClick={ onUsernameClick }
            portal={ portal }
            status={ status }
            onLogout={ onLogout }
          />
        </Header>
        <Content className={ style.content }>
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};
